<template>
  <nav class="footer__contact column">
    <h4>{{ t('footer_01') }}</h4>

    <a href="mailto:info@arcticreply.com">
      <i class="fa-solid fa-envelope"></i>
      <span>{{ t('footer_02') }}</span>
    </a>
  </nav>
</template>

<style lang="scss" scoped>
@import '../styles.scss';
</style>
